module.exports = __webpack_public_path__ + "static/media/banner_volvo_eicher.1485979e.png";